module.exports = __webpack_public_path__ + "media/Images/tpa-faq-image3-43f418b094f6bd94a05428f7c06ff698.jpg";